export const getFileType = (uploadType) => {
    if (!uploadType) return 'unknown';


    // Define the different sets of types
    const videoTypes = ['video', 'reel', 'REELS', 'STORIES'];
    const imageTypes = ['post', 'image', 'img'];

    // Check if the uploadType matches any video type
    if (videoTypes.includes(uploadType) || videoTypes.includes(uploadType.toUpperCase())) {
        return 'video';
    }

    // Check if the uploadType matches any image type
    if (imageTypes.includes(uploadType) || imageTypes.includes(uploadType.toUpperCase())) {
        return 'image';
    }

    // Return a default type or handle an unknown uploadType case
    return 'unknown';
}

export const getFileTypeFromFirebasePath = (firebasePath) => {
    if (!firebasePath) return 'unknown';

    // Remove query parameters first
    const pathWithoutQuery = firebasePath.split('?')[0];
    
    // Find the last dot in the path (which should be the file extension)
    const lastDotIndex = pathWithoutQuery.lastIndexOf('.');
    if (lastDotIndex === -1) return 'unknown';
    
    // Extract the extension from the last dot to the end
    const extension = pathWithoutQuery.substring(lastDotIndex + 1).toLowerCase();

    // Define common image and video file extensions
    const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];

    // Determine the file type based on the extension
    if (imageExtensions.includes(extension)) {
        return 'image';
    }
    if (videoExtensions.includes(extension)) {
        return 'video';
    }

    // Return 'unknown' if the extension does not match any known types
    return 'unknown';
};


